module.exports = __webpack_public_path__ + "img/stock7.1e90efd9.png";